import React from 'react';
import { useTranslation } from 'react-i18next';

const WELCOME_VIDEOS = {
  en: '/assets/videos/HirePortal_Welcome_Video_EN.mp4',
  nl: '/assets/videos/HirePortal_Welkomst_Video_NL.mp4',
};

const DemoWelcomeVideo = () => {
  const { i18n } = useTranslation();
  const locale = String(i18n.language || '').toLowerCase().startsWith('nl') ? 'nl' : 'en';
  const videoSrc = WELCOME_VIDEOS[locale];

  return (
    <div className="overflow-hidden rounded-xl border border-border bg-black shadow-elevation-sm">
      <video
        key={videoSrc}
        className="aspect-video w-full bg-black"
        src={videoSrc}
        controls
        playsInline
        preload="metadata"
      />
    </div>
  );
};

export default DemoWelcomeVideo;
